export class Publication {
    public id: string;
    public outletUrl?: string;
    public agilityOutletId: string;
    public agilityOutletURL: string;
    public name: string;
    public uuid?: string;
}
